import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguageData } from '../contexts/LanguageContext';
import Header from './Header';
import SideNav from './SideNav';
import Footer from './Footer';
import PageHeader from './PageHeader';
import PracticeModal from './PracticeModal';
import usePageTimeTracker from '../hooks/usePageTimeTracker';
import './Common.css';
import './ExploreLearning.css';

const ExploreLearning = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language: initialLanguage = 'de', proficiencyLevel: initialLevel = 'beginner-a1' } = location.state || {};
  
  console.log('ExploreLearning - location.state:', location.state);
  console.log('ExploreLearning - initialLanguage:', initialLanguage);
  console.log('ExploreLearning - initialLevel:', initialLevel);
  
  const [language, setLanguage] = React.useState(initialLanguage);
  const [proficiencyLevel, setProficiencyLevel] = React.useState(initialLevel);
  const [isPracticeModalOpen, setIsPracticeModalOpen] = React.useState(false);

  usePageTimeTracker('explore-learning', user);
  
  // Use shared language data from context
  const { loading, languages: languagesData, proficiencyLevels: levelsData } = useLanguageData();
  
  console.log('ExploreLearning - languagesData:', languagesData);
  console.log('ExploreLearning - levelsData:', levelsData);
  console.log('ExploreLearning - current language:', language);
  console.log('ExploreLearning - current level:', proficiencyLevel);

  const breadcrumbs = [
    { label: 'Home', path: '/', current: false },
    { label: 'Explore Learning', current: true }
  ];

  return (
    <div className="explore-learning">
      <Header user={user} />
      
      <div className="nav-header-container">
        <SideNav />
        <PageHeader 
          breadcrumbs={breadcrumbs}
          language={language}
          proficiencyLevel={proficiencyLevel}
          onLanguageChange={setLanguage}
          onLevelChange={setProficiencyLevel}
        />
      </div>
      
      <main className="explore-content">
        <h1 className="page-title">
          Explore the next step in your language learning journey 
        </h1>

        <div className="learning-sections">
          <div className="learning-card">
            <div className="card-illustration">
              <img src="/images/card-learn.png" alt="Learn" />
            </div>
            <h3 className="card-title">Learn</h3>
            <p className="card-description">
              Master core language concepts and usage step-by-step.
            </p>
           
            <div className="card-extra-links">
              <a 
                href="#go-to-learn" 
                className="extra-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/learn', { state: { language, proficiencyLevel } });
                }}
              >
                Go to learn
                <img src="/images/Arrow.svg" alt="" className="arrow-icon" />
              </a>
            </div>
          </div>

          <div className="learning-card">
            <div className="card-illustration">
              <img src="/images/card-practice.png" alt="Practice" />
            </div>
            <h3 className="card-title">Practice</h3>
            <p className="card-description">
              Reinforce learning through hands-on<br />language exercises.
            </p>
            <div className="card-extra-links">
              <a 
                href="#language-skills" 
                className="extra-link"
                onClick={(e) => {
                  e.preventDefault();
                  setIsPracticeModalOpen(true);
                }}
              >
                Language Skills
                <img src="/images/Arrow.svg" alt="" className="arrow-icon" />
              </a>
              <a 
                href="#business-scenario" 
                className="extra-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/practice-business', { state: { language, proficiencyLevel } });
                }}
              >
                Business Scenario
                <img src="/images/Arrow.svg" alt="" className="arrow-icon" />
              </a>
            </div>
          </div>

          <div className="learning-card">
            <div className="card-illustration">
              <img src="/images/Assessmentinactive.svg" alt="Assessment" />
            </div>
            <h3 className="card-title">Assessment</h3>
            <p className="card-description">
              Track growth and performance <br />milestones for each level.
            </p>
            <div className="card-extra-links">
              <div className="coming-soon-text">
                Coming Soon
                <img src="/images/Time.svg" alt="" className="time-icon" />
              </div>
            </div>
          </div>

          <div className="learning-card">
            <div className="card-illustration">
              <img src="/images/activeculturalinsights.svg" alt="Cultural Insights" />
            </div>
            <h3 className="card-title">Cultural Insights</h3>
            <p className="card-description">
              Explore the culture and context<br />behind language.
            </p>
            <div className="card-extra-links">
              <a className="extra-link" onClick={() => navigate('/cultural-insights', { state: { language, proficiencyLevel } })}>
                Know more <img src="/images/Arrow.svg" alt="" width="16" height="16" />
              </a>
              <a className="extra-link" onClick={() => navigate('/cultural-insights-challenge', { state: { language, proficiencyLevel } })}>
                Culture Insight Challenge <img src="/images/Arrow.svg" alt="" width="16" height="16" />
              </a>
            </div>

          </div>
        </div>
      </main>

      <Footer />
      
      <PracticeModal 
        isOpen={isPracticeModalOpen}
        onClose={() => setIsPracticeModalOpen(false)}
        language={language}
        proficiencyLevel={proficiencyLevel}
      />
    </div>
  );
};

export default ExploreLearning;
